module.exports = __webpack_public_path__ + "assets/img/32_646.97c17daa.jpg";